/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";

import { Routes, RouterModule, ExtraOptions } from "@angular/router";
import { APP_BASE_HREF } from "@angular/common";

const routes: Routes = [];
const routeOption: ExtraOptions = {
   useHash: true,
   initialNavigation: "disabled"
};

@NgModule({
   imports: [RouterModule.forRoot(routes, routeOption)],
   exports: [RouterModule],
   providers: [{ provide: APP_BASE_HREF, useValue: "/" }]
})
export class AppRoutingModule {}
